export const CJ_COOKIE_NAME = 'cje'

export const CJ_EVENT_QUERY_PARAM = 'cjevent'

export const CJ_EVENT_MAX_LENGTH = 255
